import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {TombOfNefertitiSoundConfig} from "../../TombOfNefertitiSoundConfig";
import {CoinsFountain} from "../bigwin/CoinsFountain";

export class TombOfNefertitiFreeSpinTotalWinView extends BaseView {
    private _coinsFountain:CoinsFountain;
    private _scroll:TimelineSprite;
    private _totalWin:PIXI.Text;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(TombOfNefertitiGameConfig.instance.LAYERS.FOUNTAIN.name);
        this._coinsFountain = new CoinsFountain();
    }

    protected initAnimations():void {
        const textStyle:TextStyleOptions = {
            fill : ["#fbbd16", "#fff47b", "#fbbd16"],
            fillGradientStops : [0.1, 0.5, 0.9],
            fillGradientType : 0,
            fontSize : 50,
            fontFamily : TombOfNefertitiGameConfig.instance.USABLE_FONT,
            dropShadow : true,
            dropShadowAlpha : 1,
            dropShadowAngle : 90,
            dropShadowBlur : 6,
            dropShadowColor : "#250e08",
            dropShadowDistance : 5,
            padding : 8,
            stroke : "#4a1703",
            strokeThickness : 4
        };

        let scroll:TimelineSprite = new TimelineSprite(GameResources.getTextures("totalwinscroll")),
            totalWin = new PIXI.Text(Translation.translate("TOTAL WIN"), textStyle);

        scroll.anchor.set(0.5);
        scroll.scale.set(2.5);
        scroll.position.set(TombOfNefertitiGameConfig.instance.GAME_WIDTH / 2, TombOfNefertitiGameConfig.instance.GAME_HEIGHT / 2);
        scroll.visible = false;

        totalWin.anchor.set(0.5);
        totalWin.position.set(TombOfNefertitiGameConfig.instance.GAME_WIDTH / 2, 100);
        totalWin.visible = false;

        this._layer.addChild(scroll);
        this._layer.addChild(totalWin);

        this._scroll = scroll;
        this._totalWin = totalWin;
    }

    public startPresentation(amount:number, totalWinBelowStake: boolean):void {
        this._scroll.getAnimationAutoShowHide(true, false, undefined, undefined, () => {
            if(amount > 0 && !totalWinBelowStake) {
                this._coinsFountain.startFountain(2);
            }
        });
    }

    public showTotalWinText(totalWinBelowStake: boolean): void {
        if (!totalWinBelowStake) {
            this._totalWin.visible = true;
            TweenLite.fromTo(this._totalWin, 0.5, {alpha: 0}, {alpha: 1});
            SlotGame.sound.playEffect(TombOfNefertitiSoundConfig.instance.FS_OUTRO_TEXT_REVEAL);
        }
    }

    public stopPresentation():void {
        this._coinsFountain.stopFountain();
    }

    public onFreeSpinOutroCompleting():void {
        this._totalWin.visible = false;
        this._scroll.visible = false;
    }
}